// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Dropdown } from "../../../FlowConfigurationInputs";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { timeZones } from "../../../../home/pages/automs/autom/leftSideBar/variables/timeZones/TimeZones";

// Import Material UI
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

// Import Recoil
import { initialActions, saveAvailable, changedFields, alertState } from "../../../../recoil-store/recoil-state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

const useStyles = makeStyles(theme => ({
  option: {
    '& > span': {
      marginRight: 10,
      fontSize: 12,
    },
    fontSize: 13,
    fontWeight: 600,
    color: '#46474E',
  },
  inputRoot: {
    "& fieldset": {
      borderColor: '#E6E6E6',
      borderWidth: '1.1px'
    }
  },
  popupIndicator: {
    color: "#B0B0B0",
    height: "10px",
    width: "10px"
  }
}));

export default function ConvertDate({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const actionLabel = "CONTENT.CONFIGURATION-FORM.STRING.CONVERT-STRING-TO-DATE.";
  const [sourceFormat, setSourceFormat] = useState({});
  const [newFormat, setNewFormat] = useState({});
  const [selectedTimeZone, setSelectedTimeZone] = useState({});

  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

  const options = [
    {
      value: "dd-mm-yyyy",
      label: "FORMAT-1"//"DD-MM-YYYY",
    },
    {
      value: "mm-dd-yyyy",
      label: "FORMAT-2"//"MM-DD-YYYY",
    },
    {
      value: "yyyy-mm-dd",
      label: "FORMAT-3"//"YYYY-MM-DD",
    },
    {
      value: "dd.mm.yyyy",
      label: "FORMAT-4"//"DD.MM.YYYY",
    },
    {
      value: "mm.dd.yyyy",
      label: "FORMAT-5"//"MM.DD.YYYY",
    },
    {
      value: "yyyy.mm.dd",
      label: "FORMAT-6"//"YYYY.MM.DD",
    },
    {
      value: "dd/mm/yyyy",
      label: "FORMAT-7"//"DD/MM/YYYY",
    },
    {
      value: "mm/dd/yyyy",
      label: "FORMAT-8"//"MM/DD/YYYY",
    },
    {
      value: "yyyy/mm/dd",
      label: "FORMAT-9"//"YYYY/MM/DD",
    },
    {
      value: "dd mon yyyy",
      label: "FORMAT-10"//"DD Mon YYYY",
    },
    {
      value: "mon dd, yyyy",
      label: "FORMAT-11"//"Mon DD, YYYY",
    },
    {
      value: "dd-mon-yyyy",
      label: "FORMAT-12"//"DD-Mon-YYYY",
    },
    {
      value: "day, dd month yyyy",
      label: "FORMAT-13"//"Day, DD Month YYYY",
    },
    {
      value: "dd month yyyy",
      label: "FORMAT-14"//"DD Month YYYY",
    },
    {
      value: "yyyy month dd",
      label: "FORMAT-15"//"YYYY Month DD",
    },
    {
      value: "yyyy-mm-dd hh:mm",
      label: "FORMAT-16"//"YYYY-MM-DD HH:MM",
    },
    {
      value: "dd-mm-yyyy hh:mm",
      label: "FORMAT-17"//"DD-MM-YYYY HH:MM",
    },
    {
      value: "mm-dd-yyyy hh:mm",
      label: "FORMAT-18"//"MM-DD-YYYY HH:MM",
    },
    {
      value: "yyyy/mm/dd hh:mm",
      label: "FORMAT-19"//"YYYY/MM/DD HH:MM",
    },
    {
      value: "dd/mm/yyyy hh:mm",
      label: "FORMAT-20"//"DD/MM/YYYY HH:MM",
    },
    {
      value: "mm/dd/yyyy hh:mm",
      label: "FORMAT-21"//"MM/DD/YYYY HH:MM",
    },
    {
      value: "yyyy.mm.dd hh:mm",
      label: "FORMAT-22"//"YYYY.MM.DD HH:MM",
    },
    {
      value: "mm.dd.yyyy hh:mm",
      label: "FORMAT-23"//"MM.DD.YYYY HH:MM",
    },
    {
      value: "dd mon yyyy hh:mm",
      label: "FORMAT-24"//"DD Mon YYYY HH:MM",
    },
    {
      value: "mon dd, yyyy hh:mm",
      label: "FORMAT-25"//"Mon DD, YYYY HH:MM",
    },
    {
      value: "dd-mon-yyyy hh:mm",
      label: "FORMAT-26"//"DD-Mon-YYYY HH:MM",
    },
    {
      value: "day, dd month yyyy hh:mm",
      label: "FORMAT-27"//"Day, DD Month YYYY HH:MM",
    },
    {
      value: "dd month yyyy hh:mm",
      label: "FORMAT-28"//"DD Month YYYY HH:MM",
    },
    {
      value: "yyyy month dd hh:mm",
      label: "FORMAT-29"//"YYYY Month DD HH:MM",
    },
    {
      value: "yyyy-mm-dd hh:mm:ss",
      label: "FORMAT-30"//"YYYY-MM-DD HH:MM:SS",
    },
    {
      value: "dd-mm-yyyy hh:mm:ss",
      label: "FORMAT-31"//"DD-MM-YYYY HH:MM:SS",
    },
    {
      value: "mm-dd-yyyy hh:mm:ss",
      label: "FORMAT-32"//"MM-DD-YYYY HH:MM:SS",
    },
    {
      value: "yyyy/mm/dd hh:mm:ss",
      label: "FORMAT-33"//"YYYY/MM/DD HH:MM:SS",
    },
    {
      value: "dd/mm/yyyy hh:mm:ss",
      label: "FORMAT-34"//"DD/MM/YYYY HH:MM:SS",
    },
    {
      value: "mm/dd/yyyy hh:mm:ss",
      label: "FORMAT-35"//"MM/DD/YYYY HH:MM:SS",
    },
    {
      value: "yyyy.mm.dd hh:mm:ss",
      label: "FORMAT-36"//"YYYY.MM.DD HH:MM:SS",
    },
    {
      value: "dd.mm.yyyy hh:mm:ss",
      label: "FORMAT-37"//"DD.MM.YYYY HH:MM:SS",
    },
    {
      value: "mm.dd.yyyy hh:mm:ss",
      label: "FORMAT-38"//"MM.DD.YYYY HH:MM:SS",
    },
    {
      value: "dd mon yyyy hh:mm:ss",
      label: "FORMAT-39"//"DD Mon YYYY HH:MM:SS",
    },
    {
      value: "mon dd, yyyy hh:mm:ss",
      label: "FORMAT-40"//"Mon DD, YYYY HH:MM:SS",
    },
    {
      value: "dd-mon-yyyy hh:mm:ss",
      label: "FORMAT-41"//"DD-Mon-YYYY HH:MM:SS",
    },
    {
      value: "day, dd month yyyy hh:mm:ss",
      label: "FORMAT-42"//"Day, DD Month YYYY HH:MM:SS",
    },
    {
      value: "dd month yyyy hh:mm:ss",
      label: "FORMAT-43"//"DD Month YYYY HH:MM:SS",
    },
    {
      value: "yyyy month dd hh:mm:ss",
      label: "FORMAT-44"//"YYYY Month DD HH:MM:SS",
    },
    {
      value: "yyyy-mm-ddThh:mm:ss+hh:mm",
      label: "FORMAT-45"//"YYYY-MM-DDTHH:MM:SS±HH:MM",
    },
    {
      value: "yyyy-mm-ddThh:mm:ss.sss+hhmm",
      label: "FORMAT-46"//"YYYY-MM-DDTHH:MM:SS.sss±HHMM",
    },
    {
      value: "yyyy-mm-ddThh:mm:ssz",
      label: "FORMAT-47"//"YYYY-MM-DDTHH:MM:SSZ",
    },
  ];

  useEffect(() => {
    if (!action.fields.sourceFormat) {
      action.fields.sourceFormat = { isRequired: true, value: 'dd-mm-yyyy' };
    }

    if (!action.fields.newFormat) {
      action.fields.newFormat = { isRequired: true, value: 'dd-mm-yyyy' };
    }

    let sourceFormat = options.find(x => x.value === action.fields.sourceFormat.value);
    if (sourceFormat) {
      setSourceFormat(sourceFormat);
    } else {
      setSourceFormat(options[0]);
    }

    let newFormat = options.find(x => x.value === action.fields.newFormat.value);
    if (newFormat) {
      setNewFormat(newFormat);
    } else {
      setNewFormat(options[0]);
    }

    if (action.fields.timeZone?.value) {
      let z = timeZones.find(x => x.value === action.fields.timeZone.value);
      setSelectedTimeZone(z ? z : {});
    } else {
      setSelectedTimeZone({});
    }

  }, [action.id])

  const changeManagement = (field_name, v) => {
    const field = initialActionsData[action.id]?.fields[field_name];
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated(field_name, action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);
  }

  const changeSourceFormat = (v) => {
    setSourceFormat(v ? v : {});
    let value = v ? v.value : "";
    action.fields.sourceFormat.value = value
    changeManagement("sourceFormat", value);
  }

  const changeNewFormat = (v) => {
    setNewFormat(v ? v : {});
    let value = v ? v.value : "";
    action.fields.newFormat.value = value
    changeManagement("newFormat", value);
  }

  const classes = useStyles();

  const changeTimeZone = (v) => {
    setSelectedTimeZone(v);
    changeManagement("timeZone", v ? v.value : "");
    action.fields.timeZone = { value: v.value };
  }

  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "SOURCESTRING")} is_required />
        <TextInput
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          inputName="sourceString"
          isRequired={true}
          fieldType="string" displayName={t(label + 'SOURCESTRING')}
          hideRequired
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "SOURCE-FORMAT-TYPE")} is_required />
        <Autocomplete
          value={sourceFormat}
          onChange={(e, newValue) => changeSourceFormat(newValue)}
          id="date-source-format"
          style={{ width: 253, position: 'relative', background: '#FBFBFB' }}
          size="small"
          options={options}
          classes={{
            option: classes.option,
            inputRoot: classes.inputRoot,
            popupIndicator: classes.popupIndicator
          }}
          autoHighlight
          getOptionLabel={(option) => option.label ? t(actionLabel + option.label) : ""}
          renderOption={(option) => (
            <>
              {t(actionLabel + option.label)}
            </>
          )}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                id='select-source-format'
                className="select-action-input"
                placeholder={t(actionLabel + "SELECT-SOURCE-FORMAT")}
                variant="outlined"
                classes={{
                  root: classes.inputRoot
                }}
                inputProps={{
                  ...params.inputProps,
                  "aria-autocomplete": 'new-password',
                  autoComplete: 'new-password', // disable autocomplete and autofill
                  style: {
                    marginLeft: '5px',
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#46474E'
                  }
                }}
              />
            </>
          )}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "DATE-FORMAT-TYPE")} is_required />
        <Autocomplete
          value={newFormat}
          onChange={(e, newValue) => changeNewFormat(newValue)}
          id="date-new-format"
          style={{ width: 253, position: 'relative', background: '#FBFBFB' }}
          size="small"
          options={options}
          classes={{
            option: classes.option,
            inputRoot: classes.inputRoot,
            popupIndicator: classes.popupIndicator
          }}
          autoHighlight
          getOptionLabel={(option) => option.label ? t(actionLabel + option.label) : ""}
          renderOption={(option) => (
            <>
              {t(actionLabel + option.label)}
            </>
          )}
          renderInput={(params) => (
            <>
              <TextField
                {...params}
                id='select-new-format'
                className="select-action-input"
                placeholder={t(actionLabel + "SELECT-NEW-FORMAT")}
                variant="outlined"
                classes={{
                  root: classes.inputRoot
                }}
                inputProps={{
                  ...params.inputProps,
                  "aria-autocomplete": 'new-password',
                  autoComplete: 'new-password', // disable autocomplete and autofill
                  style: {
                    marginLeft: '5px',
                    fontSize: 12,
                    fontWeight: 600,
                    color: '#46474E'
                  }
                }}
              />
            </>
          )}
        />
      </div>

      {/* <div className="conf-field-container">
        <FieldLabel name={t(label + "SOURCE-FORMAT-TYPE")} />
        <Dropdown
          action={action}
          inputName="sourceFormat"
          options={options.dropdown}
          isRequired={true}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "DATE-FORMAT-TYPE")} />
        <Dropdown
          action={action}
          inputName="newFormat"
          options={options.dropdown}
          isRequired={true}
        />
      </div>
      */}
      <div className="conf-field-container">
        <FieldLabel name={t("CONTENT.AUTOMS-LIST.TIME-ZONE")} />
        <Autocomplete
          value={selectedTimeZone}
          onChange={(e, newValue) => changeTimeZone(newValue ? newValue : {})}
          id={`variable-time-zone`}
          style={{ position: 'relative', background: '#FBFBFB' }}
          size="small"
          options={timeZones}
          classes={{
            option: classes.option,
            inputRoot: classes.inputRoot,
            popupIndicator: classes.popupIndicator
          }}
          autoHighlight
          getOptionLabel={(option) => option.value ? `${option.value} ${option.dst ? `(Standard: ${option.utc}, DST: ${option.dst})` : `(${option.utc})`}` : ""}
          renderOption={(option) => (
            <>
              {`${option.value} ${option.dst ? `(Standard: ${option.utc}, DST: ${option.dst})` : `(${option.utc})`}`}
            </>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              id='select-time-zone-convert-date'
              className="select-action-input"
              placeholder={t("CONTENT.AUTOMS-LIST.SELECT-TIME-ZONE")}
              variant="outlined"
              classes={{
                root: classes.inputRoot
              }}
              inputProps={{
                ...params.inputProps,
                "aria-autocomplete": 'new-password',
                autoComplete: 'new-password', // disable autocomplete and autofill
                style: {
                  marginLeft: '5px',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#46474E'
                }
              }}
            />
          )}
        />
        <small className="conf-field-desc"><em>{t('CONTENT.AUTOMS-LIST.BASED-ON-SYSTEM-TIME-ZONE')}</em></small>
      </div>


      <div className="conf-field-container">
        <FieldLabel name={t(label + "ASSIGN_TO_VARIABLE")} is_required />
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          filter="date"
          isRequired={true}
          hideRequired
        />
        <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'date' })}</em></small>
      </div>
    </div>
  );
}